import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {ComponentsModule} from '../components/components.module';
import {TranslateModule} from '@ngx-translate/core';
import {ConferenceRoutingModule} from './conference-routing.module';
import {ConferencePageComponent} from './conference/conference.page';
import {PipesModule} from '../../pipes/pipes.module';
import {ConferenceComponentsModule} from './components/components.module';
import {CardComponent} from './components/card/card.component';
import {TestComponent} from './test/test.component'; // TO delete
import {WordCloudComponent} from './components/word-cloud/word-cloud.component';
import {CardWrapperComponent} from './components/card-wrapper/card-wrapper.component';
import {ConferenceResultsPageComponent} from './results/results.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ConferenceRoutingModule,
    ComponentsModule,
    ConferenceComponentsModule,
    TranslateModule.forChild(),
    PipesModule,
    CardComponent,
    CardWrapperComponent,
    WordCloudComponent
  ],
  exports: [],
  declarations: [
    ConferencePageComponent,
    ConferenceResultsPageComponent,
    TestComponent,
  ]
})
export class ConferenceModule {
}
